import {loadBlockLazyImages, loadElementLazyImage} from "../helpers/lazy-load";
//import {smoothScrollCreate, smoothScrollKill} from "../scroll-smoother";
import { gsap, Power2 } from 'gsap'


let windowHeight = window.innerHeight
let popupOpenFlag = false

$(document).on('click', '.js-open-popup', function() {
  popupOpenFlag = true
  windowHeight = window.outerHeight
  let popup_name = $(this).data('popup')
  let popup = $('.js-popup[data-popup="'+ popup_name +'"]')

  if (popup.length){

    if (popup_name == 'video-popup-global'){
      let title = $(this).data('global-title')
      let video = $(this).data('global-video')
      let text = $(this).data('global-text')

      if (title) popup.find('.js-title')[0].innerHTML = title.trim().startsWith("{") ? JSON.parse(title) : title;
      if (video) popup.find('.js-video').attr('data-img-src', video)
      if (text) popup.find('.js-text')[0].innerHTML = text.trim().startsWith("{") ? JSON.parse(text) : text;
      popup.find('.js-text').find('.js-fade-when-in-screen').css('opacity', 1).css('transform', 'translateY(0)')

      if (!title) { popup.find('.js-title').hide() } else { popup.find('.js-title').show }
      if (!title) { popup.find('.js-text').hide() } else { popup.find('.js-text').show }
    }

    if (popup_name == 'img-popup-global'){
      let title = $(this).data('global-title')
      let image = $(this).data('global-image')
      let text = $(this).data('global-text')

      if (title) popup.find('.js-title')[0].innerHTML = title.trim().startsWith("{") ? JSON.parse(title) : title;
      if (image) popup.find('.js-image').attr('src', image)
      if (text) popup.find('.js-text')[0].innerHTML = text.trim().startsWith("{") ? JSON.parse(text) : text;
      popup.find('.js-text').find('.js-fade-when-in-screen').css('opacity', 1).css('transform', 'translateY(0)')

      if (!title) { popup.find('.js-title').hide() } else { popup.find('.js-title').show }
      if (!title) { popup.find('.js-text').hide() } else { popup.find('.js-text').show }
    }

    popup.show()
    gsap.to(popup, {duration: 1, top: 0, ease: 'power2'});

    // load lazy data
    loadBlockLazyImages(popup)


    // if video popup play video
    if (popup.hasClass('video-popup')){
      gsap.to(popup.find('video'), {duration: 1, top: 0, delay: 0.5, ease: 'power2'});

      let video = popup.find('video')
      if (video.length){
        video[0].play()
        video[0].volume = 1
      }
    }


    $('html').addClass('modal-open')

    //smoothScrollKill()
  }
})


$(document).on('click', '.js-close-popup', function(){
  closePopup($(this))
})

$(document).keyup(function(e) {
  if (e.key === "Escape") { // escape key maps to keycode `27`
    closePopup($('.js-popup'))
  }
});




function closePopup(el){
  popupOpenFlag = false
  let popup = el.closest('.js-popup')
  let video = popup.find('video')

  if (video.length) {
    video[0].pause()
  }

  gsap.to(popup, {duration: 1, top: "100vh", ease: 'power2', onComplete: ()=> {
    if (popupOpenFlag) return false
    popup.hide()
    gsap.set(popup.find('video'), {top: '30vh'});

    $('html').removeClass('modal-open')
    //smoothScrollCreate()
  }
  });
  
}
